import GoToTop from './GoToTop';
import { IGoToTopProps as IGoToTop } from './GoToTop.interface';

export default GoToTop;
export { GoToTop, IGoToTop };
